/**
 * The slim bar that sits under the conversation header whenever at least
 * one message is pinned: the newest pinned message on one line, plus a
 * count when more than one is pinned. This item builds and tests the
 * component; WI-W12 places it under the header.
 */
import { useChatListPins } from "@sportsmet/messaging-sdk/private";
import type { ReactNode } from "react";

import { pinBodyLabel, pinnedBarLabel } from "./pinDisplay";

export type typePinnedBarProps = {
  chatId: string;
  onJumpToMessage: (messageId: string) => void;
};

export const PinnedBar = (props: typePinnedBarProps): ReactNode => {
  const chatListPins = useChatListPins({ chatId: props.chatId });
  const data = chatListPins.data?.data;

  if (!data || data.total === 0) return null;

  const newest = data.items[0];
  if (!newest) return null;

  const countLabel = pinnedBarLabel(data.total);

  return (
    <button
      type="button"
      data-testid="pinned-bar"
      className="flex min-h-touch-target w-full items-center gap-2 border-b border-hairline bg-surface-secondary px-4 text-left"
      onClick={() => {
        props.onJumpToMessage(newest.messageId);
      }}
    >
      <span className="line-clamp-1 flex-1 text-body text-ink">
        {pinBodyLabel(newest)}
      </span>
      {countLabel !== null ? (
        <span className="shrink-0 text-caption text-ink-secondary">
          {countLabel}
        </span>
      ) : null}
    </button>
  );
};
